<panel width="450">
    @if (productPlans) {
        <form>
            <h1>{{ headline | translate }}</h1>
            <section>
                <custom-select [label]="label | translate"
                    [placeholder]="'general.none' | translate"
                    [selectList]="productPlans"
                    [(value)]="selectedProductPlanId"
                    [required]="required"></custom-select>
            </section>
            <section>
                <button confirm (click)="saveChanges()" [label]="buttonText | translate"></button>
            </section>
        </form>
    }
</panel>
